import { TextArea } from '@dealstack/frontend/shared/components/forms/TextArea/TextArea';
import styled from 'styled-components';

export const DeclarationsWrapper = styled.div`
	margin-top: 2.5em;
	display: flex;
	flex-direction: column;
	gap: 2em;
`;

export const SingleDeclarationWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2em;

	${TextArea} {
		margin-top: 0.5rem;
	}
`;

export const SummaryGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;
`;

export const SummarySection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;
